export default __webpack_public_path__ + "static/media/banner-400x220-sandwiches.ae7f730a.jpg";